import { render, staticRenderFns } from "./addPilotModal.vue?vue&type=template&id=70cd72a4&"
import script from "./addPilotModal.vue?vue&type=script&lang=js&"
export * from "./addPilotModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports